import React, {Component} from "react";
import InstrumentView from "./InstrumentView";
import {Growl} from "primereact/growl";
import {Button} from "primereact/button";
import ContextMenu from "../../../components/contextMenu";
import {
    ADD_INSTRUMENT_ROUTE,
    EDIT_INSTRUMENT_ROUTE,
    MAINTENANCE_INSTRUMENT_ROUTE,
} from "../../../utils/constants/RoutesConstants";
import {
    MAINTENANCE_INSTRUMENT,
} from "../../../utils/constants/Constants";
import {HIGH_AVAILABILITY, LOW_AVAILABILITY, MEDIUM_AVAILABILITY} from "../../../utils/constants/Constants";
import {CatalogService} from "../../../service/catalog/CatalogService";
import {TrendingDown, TrendingFlat, TrendingUp} from '@material-ui/icons';
import {InstrumentService} from "../../../service/maintenance/instrument/InstrumentService";

export default class InsrumentContainer extends Component {
    constructor(props) {
        super(props);
        this.catalogService = new CatalogService();
        this.instrumentService = new InstrumentService();
        this.getDataInstruments = this.getDataInstruments.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.confirmationRef = null;
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        this.state = {
            dataInstruments: this.getDataInstruments(),
            isLoading: true,
            exportOptions: [
                {label: "Excel", action: this.exportExcel},
            ],
            selectedInstrument: []
        };

        this.onSelectionChangeTable = this.onSelectionChangeTable.bind(this);
        this.instrumentActionTemplate = this.instrumentActionTemplate.bind(this);
        this.redirectAddInstrument = this.redirectAddInstrument.bind(this);
        this.loading = this.loading.bind(this);
    }

    loading(opt) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: opt ? opt : false,
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    formatAvailability(rowData, column) {
        let format = "";
        let availability = rowData[column['field']];
        switch (availability) {
            case HIGH_AVAILABILITY:
                format = <div><TrendingUp/>&nbsp;&nbsp;{rowData['descDemanda']}</div>;
                break;
            case MEDIUM_AVAILABILITY:
                format = <div><TrendingFlat/>&nbsp;&nbsp;{rowData['descDemanda']}</div>;
                break;
            case LOW_AVAILABILITY:
                format = <div><TrendingDown/>&nbsp;&nbsp;{rowData['descDemanda']}</div>;
                break;
            default:
                format = rowData['descDemanda'];
                break;
        }
        return format;
    }

    getDataInstruments() {
        this.loading(true);
        return this.catalogService.getCatalogInstrument()
            .then(resp => {
                this.setState({
                    dataInstruments: resp,
                });
                this.loading(false);
            })
    }

    /**
     * Función que exporta lo que se encuentra en la tabla a un documento de
     * excel. Para ello, hace una petición al back por medio de
     * MaintenanceUsersService.
     */
    exportExcel() {
        this.loading(true);
        this.instrumentService.exportInstrumentXLS()
            .then(resp => {
                this.loading(false)
            });
    }


    onSelectionChangeTable(event) {
        this.setState({selectedUsers: event.value,})
    }

    /**
     * Función que redirecciona a la pantalla de editar
     */
    redirectEditInstrument(rowData) {
        this.props.history.push({
            pathname: EDIT_INSTRUMENT_ROUTE,
            state: {
                returnPath: MAINTENANCE_INSTRUMENT_ROUTE,
                instrumentSelected: rowData,
            },
        });
    }

    instrumentActionTemplate(rowData, column) {
        return (
            <Button label="Editar"
                    className="p-button-secondary"
                    onClick={() => this.redirectEditInstrument(rowData)}/>
        );
    }

    /**
     * Función que redirecciona a la pantalla de agregar emisora
     */
    redirectAddInstrument() {
        this.props.history.push({
            pathname: ADD_INSTRUMENT_ROUTE,
            state: {
                callScreen: MAINTENANCE_INSTRUMENT,
                returnPath: MAINTENANCE_INSTRUMENT_ROUTE,
            },
        });
    }

    render() {
        let exportMenu = <ContextMenu menuOptions={this.state.exportOptions} isButton={true} label="Exportar"/>;

        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {dataInstruments, isLoading, selectedInstrument} = this.state;

        return <InstrumentView dataInstruments={dataInstruments}
                               messagesGrowl={messagesGrowl}
                               exportMenu={exportMenu}
                               selectedInstrument={selectedInstrument}
                               formatAvailability={this.formatAvailability}
                               instrumentActionTemplate={this.instrumentActionTemplate}
                               onSelectionChangeTable={this.onSelectionChangeTable}
                               getDataInstruments={this.getDataInstruments}
                               isLoading={isLoading}
                               redirectAddInstrument={this.redirectAddInstrument}
        />
    }
};